export default class SearchResultsSelection {
  constructor() {
    this.availableSelections = ['categories', 'products']
  }

  setItems(items) {
    this.selectionType = items.categories.length > 0 ? 'categories' : 'products'
    this.selections = {
      categories: {
        index: -1,
        maxIndex: items.categories.length - 1,
      },

      products: {
        index: -1,
        maxIndex: items.products.length - 1,
      },
    }

    return this
  }

  current() {
    return {
      type: this.selectionType,
      index: this.selections[this.selectionType].index,
      maxIndex: this.selections[this.selectionType].maxIndex,
    }
  }

  down() {
    const current = this.current()

    if (current.index < current.maxIndex) {
      this.selections[this.selectionType].index++

      return this.current()
    }

    if (this.canJumpToNextSelectionType()) {
      this.selectionType = this.nextSelectionType()
      console.log(`[Next] Jumped to "${this.selectionType}" selection type.`)
      this.selections[this.selectionType].index = 0

      return this.current()
    }

    return current
  }

  up() {
    const current = this.current()
    const canJump = this.canJumpToPreviousSelectionType()

    if (current.index > 0 || (current.index === 0 && !canJump)) {
      this.selections[this.selectionType].index--

      return this.current()
    }

    if (canJump) {
      this.selectionType = this.previousSelectionType()
      console.log(`[Prev] Jumped to "${this.selectionType}" selection type.`)
      this.selections[this.selectionType].index = this.selections[this.selectionType].maxIndex

      return this.current()
    }

    return current
  }

  selectionTypeIndex() {
    return this.availableSelections.findIndex(v => v === this.selectionType)
  }

  canJumpToNextSelectionType() {
    if (this.selectionTypeIndex() >= this.availableSelections.length - 1) {
      return false
    }

    return this.selections[this.nextSelectionType()].maxIndex > 0
  }

  nextSelectionType() {
    return this.availableSelections[this.selectionTypeIndex() + 1]
  }

  canJumpToPreviousSelectionType() {
    return this.selectionTypeIndex() > 0
  }

  previousSelectionType() {
    return this.availableSelections[this.selectionTypeIndex() - 1]
  }
}
